<cache-date></cache-date>

<filterForm [addFilterParams]="filter.addFilterParams"></filterForm>
<br>

<br><hr>
<chart [data]="mailChart.data" [options]="mailChart.options" [sextant]="'mailChart'"></chart>

<br><hr>
<chart [data]="regChart.data" [options]="regChart.options" [sextant]="'regChart'"></chart>

<br><hr>
<chart [data]="browserChart.data" [options]="browserChart.options" [sextant]="'browserChart'"></chart>


<br><hr>
<chart [data]="activityChart.data" [options]="activityChart.options" [sextant]="'activityChart'"></chart>
